<div class="tabbable__body rounded-top-right no-margin">
  <h3>Här kan du administrera tillgängliga programformat</h3>
    <p>
      Notera att enbart konfigurerade programformat här går att importera
      estimat för.
    </p>

    @if (show.estimatesHaveChanged) {
      <import-warning></import-warning>
    }

    @if (omsCatalog) {
      <p e2e-id="oms-catalog-status">
        @if (omsCatalog.synced_at) {
          OMS-programkatalog senast synkad {{ omsCatalog.synced_at | date: 'yyyy-MM-dd HH:mm' }}.
        } @else {
          OMS-programkatalog har inte synkats än.
        }
        @if (omsCatalog.last_error) {
          <span class="text--warning text--strong">
            <span class="icon-warning"></span>
            Senaste synken misslyckades {{ omsCatalog.last_error_at | date: 'yyyy-MM-dd HH:mm' }}:
            {{ omsCatalog.last_error }}
          </span>
        } @else if (omsCatalogStale) {
          <span class="text--warning text--strong">
            <span class="icon-warning"></span>
            Katalogen är äldre än 6 timmar.
          </span>
        }
      </p>
    }

    <div class="divider margin-top-bottom--2x"></div>

    <div class="container">
      <div class="left-item">
        @if (!show.isEditing) {
          <button class="button primary-1" (click)="openCard('program')" [scrollTo]="newItemProgramFormat">
            Nytt programformat
          </button>
          <button
            class="button secondary"
            (click)="setEditingDistribution(true)"
            scrollTo="newItemProgramFormat"
          >
            Redigera fördelning
          </button>
        } @else {
          <button
            class="button primary-1"
            [disabled]="programFormatsForm.invalid"
            (click)="save()"
          >
            Spara
          </button>
          <button class="link" (click)="cancelEditing()">Avbryt redigering</button>
        }
      </div>
      <div class="right-item">
        <div class="dropdown filter-dropdown">
          <woo-dropdown
            [items]="categories"
            [(ngModel)]="selectedCategory"
            inputId="select-category"
            labelText="Filtrera på kategori"
            notFoundText="Inga val hittades."
            [clearable]="true"
          ></woo-dropdown>
        </div>
      </div>
    </div>
  <div class="sticky-header">

    <h3>Tillgängliga programformat</h3>
  </div>

  <table
    class="table table--woo table--info table--hover table--align--middle"
    ngForm
    #programFormatsForm="ngForm"
  >
    <thead class="sticky-table-head">
      <tr>
        <th colspan="3"></th>
        <th colspan="2" class="text-center">Fördelning&nbsp;Preroll</th>
        <th colspan="3"></th>
      </tr>
      <tr [ngClass]="showMidroll ? 'text--small' : ''">
        <th class="text--thin capitalize--first-letter">Programformat</th>
        <th class="text--thin capitalize--first-letter">Kategori</th>
        <th class="text--thin capitalize--first-letter">Datum</th>
        <th class="text--thin capitalize--first-letter">Adresserbar&nbsp;TV</th>
        <th class="text--thin capitalize--first-letter">Online&nbsp;Video</th>

        @if (showMidroll) {
          <th class="text--thin capitalize--first-letter">Adresserbar&nbsp;TV</th>
          <th class="text--thin capitalize--first-letter">Online&nbsp;Video</th>
        }

        <th class="text--thin capitalize--first-letter">Bokningsbar</th>
        <th class="text--thin" title="Finns i OMS programkatalog">OMS</th>
        <th></th>
      </tr>
    </thead>

    @if (!show.loading) {
      <tbody>
        @for (
          programFormat of programFormats;
          let index = $index;
          track index
        ) {
          <tr
            [hidden]="!rowVisible(programFormat)"
            [ngClass]="openTab(programFormat) ? 'row-card-clicked' : ''"
            style="height: 65px;"
          >
            <td class="text--thin vertical-align--middle">
              {{ programFormat.name }}
            </td>
            <td class="text--thin vertical-align--middle">
              {{ programFormat.category_name }}
            </td>
            <td class="text--thin vertical-align--middle">
              @for (
                period of filterPeriods(programFormat.periods);
                let index2 = $index;
                track index2
              ) {
                {{
                  formatterService.formatPeriod(
                    period?.start_date,
                    period?.end_date
                  )
                }}
              }
              @if (!programFormat.periods.length) {
                <b class="text-danger">
                  <span class="icon-warning"></span> Lager saknas
                </b>
              }
            </td>

            <td class="vertical-align--middle">
              @if (!show.isEditing) {
                <span>
                  {{
                    programShareLongform(
                      programFormat.product_format_program_share
                    ).preroll | percent: '1.0-3'
                  }}
                </span>
              } @else {
                <div class="input__container">
                  <input
                    name="row-{{ index }}-sharesLongformPreroll"
                    [(ngModel)]="
                      programShareLongform(
                        programFormat.product_format_program_share
                      ).preroll
                    "
                    wooPercentFormatter
                    [wooMinValidator]="0"
                    [wooMaxValidator]="1"
                    required
                    (ngModelChange)="autoFill(programFormat.product_format_program_share, inputFieldIds.prerollLongform)"
                  />
                </div>
              }
            </td>

            <td class="vertical-align--middle">
              @if (!show.isEditing) {
                <span>
                  {{
                    programShareShortform(
                      programFormat.product_format_program_share,
                      shortformId
                    ).preroll | percent: '1.0-3'
                  }}
                </span>
              } @else {
                <div class="input__container wide-input">
                  <input
                    name="row-{{ index }}-sharesShortformPreroll"
                    [(ngModel)]="
                      programShareShortform(
                        programFormat.product_format_program_share,
                        shortformId
                      ).preroll
                    "
                    wooPercentFormatter
                    [wooMinValidator]="0"
                    [wooMaxValidator]="1"
                    required
                    (ngModelChange)="autoFill(programFormat.product_format_program_share, inputFieldIds.prerollShortform)"
                  />
                </div>
              }
            </td>

            @if (showMidroll) {
              <td class="vertical-align--middle text-center">
                @if (!show.isEditing) {
                  <span>
                    {{
                      programShareLongform(
                        programFormat.product_format_program_share
                      ).midroll | percent: '1.0-3'
                    }}
                  </span>
                } @else {
                  <div class="input__container">
                    <input
                      name="row-{{ index }}-sharesLongformMidroll"
                      [(ngModel)]="
                        programShareLongform(
                          programFormat.product_format_program_share
                        ).midroll
                      "
                      wooPercentFormatter
                      [wooMinValidator]="0"
                      [wooMaxValidator]="1"
                      required
                      (ngModelChange)="autoFill(programFormat.product_format_program_share, inputFieldIds.midrollLongform)"
                    />
                  </div>
                }
              </td>

              <td class="vertical-align--middle text-center">
                @if (!show.isEditing) {
                  <span>
                    {{
                      programShareShortform(
                        programFormat.product_format_program_share,
                        shortformId
                      ).midroll | percent: '1.0-3'
                    }}
                  </span>
                } @else {
                  <div class="input__container">
                    <input
                      name="row-{{ index }}-sharesShortformMidroll"
                      [(ngModel)]="
                        programShareShortform(
                          programFormat.product_format_program_share,
                          shortformId
                        ).midroll
                      "
                      wooPercentFormatter
                      [wooMinValidator]="0"
                      [wooMaxValidator]="1"
                      required
                      (ngModelChange)="autoFill(programFormat.product_format_program_share, inputFieldIds.midrollShortform)"
                    />
                  </div>
                }
              </td>
            }

            <td>
              <div class="input__container">
                <toggle
                  name="row-{{ index }}-active"
                  [(ngModel)]="programFormat.active"
                  [ngModelOptions]="{ standalone: true }"
                  id="{{ programFormat.id }}"
                  (ngModelChange)="toggleActiveFormat(programFormat)"
                ></toggle>
              </div>
            </td>

            <td class="text--thin vertical-align--middle" e2e-id="oms-bookable">
              {{ programFormat.oms_bookable ? 'Ja' : 'Nej' }}
            </td>

            <td
              class="text-center"
              (click)="setSelected(programFormat.id)"
              style="cursor: pointer;"
            >
              <span
                class="chevron"
                [ngClass]="openTab(programFormat) ? 'bottom' : ''"
              ></span>
            </td>
          </tr>
          <tr
            [hidden]="!rowVisible(programFormat)"
            [ngStyle]="!openTab(programFormat) && { display: 'none' }"
          >
            <td colspan="10">
              <div class="row-container">
                <div class="input__container override-table-input col-3">
                  <label for="row-{{ index }}-name">Namn</label>

                  @if (!isEditing(programFormat.id)) {
                    <p>{{ programFormat.name }}</p>
                  } @else {
                    <input
                      type="text"
                      name="row-{{ index }}-name"
                      [(ngModel)]="programFormat.name"
                      required
                    />
                  }
                </div>

                <div class="input__container override-table-input col-3">
                  <label for="row-{{ index }}-mrmId">MRM&nbsp;Id</label>

                  @if (!isEditing(programFormat.id)) {
                    <p>{{ programFormat.mrm_id }}</p>
                  } @else {
                    <input
                      type="text"
                      name="row-{{ index }}-mrmId"
                      [(ngModel)]="programFormat.mrm_id"
                      required
                    />
                  }
                </div>

                <div class="input__container override-table-input col-2">
                  @if (!isEditing(programFormat.id)) {
                    <label for="row-{{ index }}-publisher">Publicist</label>
                    <p>{{ programFormat.publisher_name }}</p>
                  } @else {
                    <woo-dropdown
                      [items]="publishers"
                      [(ngModel)]="programFormat.publisher_name"
                      name="row-{{ index }}-publisher"
                      labelText="Publicist"
                      [searchAttributes]="['name']"
                      notFoundText="Inga publicister hittades."
                      placeholder="Välj..."
                      [disabled]="true"
                      required
                    ></woo-dropdown>
                  }
                </div>

                <div class="input__container override-table-input col-3">
                  @if (!isEditing(programFormat.id)) {
                    <label for="row-{{ index }}-category">Kategori</label>
                    <p>{{ programFormat.category_name }}</p>
                  } @else {
                    <woo-dropdown
                      [items]="categories"
                      [(ngModel)]="programFormat.category_id"
                      name="row-{{ index }}-category"
                      bindLabel="name"
                      bindValue="id"
                      inputId="category-search"
                      labelText="Kategori"
                      [searchAttributes]="['name']"
                      notFoundText="Inga kategorier hittades."
                      placeholder="Välj..."
                    ></woo-dropdown>
                  }
                </div>

                <div class="input__container override-table-input col-3">
                  <label for="row-{{ index }}-omsName">OMS-namn</label>

                  @if (!isEditing(programFormat.id)) {
                    <p>{{ programFormat.oms_name || '-' }}</p>
                  } @else {
                    <input
                      type="text"
                      id="row-{{ index }}-omsName"
                      name="row-{{ index }}-omsName"
                      [(ngModel)]="programFormat.oms_name"
                    />
                  }
                </div>

                <div class="input__container override-table-input col-3">
                  <label class="toggle-label" for="row-{{ index }}-site_group">Styrd mot site&nbsp;group</label>
                  <div [class.v-align]="isEditing(programFormat.id)">
                    <toggle
                      name="row-{{ index }}-site_group"
                      [(ngModel)]="programFormat.is_site_group"
                      [ngModelOptions]="{ standalone: true }"
                      id="{{ programFormat.id }}"
                      [disabled]="!isEditing(programFormat.id)"
                    ></toggle>
                  </div>
                </div>
              </div>

                @if (!isEditing(programFormat.id)) {
                  <button
                    (click)="setEditingDetails(true, programFormat.id)"
                    class="button"
                  >
                    <span class="icon-edit icon__semi-medium"></span>
                    Redigera&nbsp;programformat
                  </button>
                } @else {
                  <div class="row">
                    <div class="col-xs-4 margin-left--2x margin-top--2x">
                      <button
                        class="button primary"
                        [disabled]="programFormatsForm.invalid"
                        (click)="save(programFormat.id)"
                      >
                        Spara
                      </button>
                      <button class="link" (click)="cancelEditing()">Avbryt&nbsp;redigering</button>
                    </div>
                  </div>
                }
            </td>
          </tr>
        }
      </tbody>
    }

  </table>

  <dot-loader [visibility]="show.loading" [large]="true"></dot-loader>

  <div #newItemProgramFormat>
    @if (show.newProgramFormatForm) {
        <div class="sub-card col-12">
          <h3>Nytt Programformat</h3>
          <create-new-program-format
          [newProgramFormat]="show.newProgramFormatForm"
          (onClose)="closeCard()"
          (onCreateNewProgramFormat)="addNewFormat($event)"
          ></create-new-program-format>
        </div>
      }
  </div>
</div>
